var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback } from "react";
import { useDropzone } from "react-dropzone";
import FileCard from "./FileCard";
import Notification from "../../App/components/Notification";
import { Tooltip } from "@mui/material";
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import InfoIcon from "@mui/icons-material/Info";
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
function UploadArea(_a) {
    var isUpdate = _a.isUpdate, fileData = _a.fileData, setFileData = _a.setFileData, setFileArchive = _a.setFileArchive, imported = _a.imported, setProgress = _a.setProgress, progress = _a.progress, fileStatus = _a.fileStatus, result = _a.result, setCsvData = _a.setCsvData, csvData = _a.csvData, csvName = _a.csvName, selectService = _a.selectService, onDelete = _a.onDelete, onConfirmImport = _a.onConfirmImport, errorMessage = _a.errorMessage, selectedAction = _a.selectedAction;
    var handleFile = function (file) {
        var reader = new FileReader();
        var newFile = {
            name: file.name,
            size: file.size,
            progress: 0,
        };
        setFileArchive(file);
        setFileData(newFile);
        setProgress(0);
        reader.readAsText(file);
        reader.onprogress = function (loadedData) {
            if (loadedData.lengthComputable) {
                var progressValue = ((loadedData.loaded / loadedData.total) * 100).toFixed(2);
                setProgress(Number(progressValue));
                newFile.progress = Number(progressValue);
            }
        };
        reader.onload = function (event) {
            var _a;
            var text = (_a = event.target) === null || _a === void 0 ? void 0 : _a.result;
            var lines = text.split(/\r\n|\n|\r/).filter(function (line) { return line.trim() !== ''; });
            var data = lines.map(function (line) { return line.split(','); });
            setCsvData(data);
        };
        reader.onerror = function () {
            Notification().Notify.failure('Erro ao ler o arquivo!');
        };
    };
    var onDropAccepted = useCallback(function (acceptedFiles) {
        acceptedFiles.forEach(function (file) {
            handleFile(file);
        });
    }, []);
    var onDropRejected = useCallback(function (fileRejections) {
        fileRejections.forEach(function (item) {
            var message = '';
            switch (item.errors[0].code) {
                case 'file-invalid-type':
                    message = 'O formato do arquivo deve ser .csv';
                    break;
                case 'too-many-files':
                    message = 'Arraste um arquivo por vez!';
                    break;
                default:
                    message = item.errors[0].message;
            }
            Notification().Notify.failure("Erro ao fazer o upload do arquivo ".concat(item.file.name, ": ").concat(message));
        });
    }, []);
    var _b = useDropzone({ onDropAccepted: onDropAccepted, onDropRejected: onDropRejected, accept: ['.csv'], maxFiles: 1, multiple: false, disabled: selectService === '', }), getRootProps = _b.getRootProps, getInputProps = _b.getInputProps, isDragActive = _b.isDragActive;
    return (_jsxs(_Fragment, { children: [!fileData && (_jsx(Tooltip, __assign({ title: selectService === '' ? 'Selecione um serviço primeiro!' : undefined }, { children: _jsxs("div", __assign({ className: "container-upload-import-subscribers" }, getRootProps(), { style: { opacity: selectService === '' ? '.5' : '' } }, { children: [_jsx(UploadFileIcon, { className: "icon-upload-import" }), _jsx("input", __assign({ id: "input-file" }, getInputProps())), isDragActive ? (_jsx("div", __assign({ className: "text-upload" }, { children: _jsx("p", { children: "Solte o arquivo aqui e aguarde o upload e processamento dos dados." }) }))) : (_jsx("div", __assign({ className: "text-upload" }, { children: _jsxs("p", { children: [_jsx("span", { children: "Clique para fazer upload" }), " ou arraste e solte."] }) })))] })) }))), fileData && (_jsxs(_Fragment, { children: [fileStatus === "warning" ? (_jsxs("div", __assign({ className: "warning-message" }, { children: [_jsx(InfoIcon, { fontSize: "small", style: { marginRight: '.5rem' } }), _jsx("span", { children: "Clique no \u00EDcone " }), _jsx(FileDownloadOutlinedIcon, { fontSize: "small", style: { marginInline: '.2rem' } }), _jsx("span", { children: "abaixo para visualizar o relat\u00F3rio de erros" })] }))) : (fileStatus === "error" &&
                        _jsxs("div", __assign({ className: "error-message" }, { children: [_jsx(InfoIcon, { fontSize: "small", style: { marginRight: '.5rem' } }), _jsx("span", { children: "Passe o mouse no \u00EDcone" }), _jsx(ReportProblemIcon, { fontSize: "small", style: { marginInline: '.2rem' } }), _jsx("span", { children: "abaixo para visualizar o erro" })] }))), _jsx(FileCard, { name: fileData.name, size: fileData.size, finalProgress: fileData.progress, fileStatus: fileStatus, progress: progress.toString(), processed: imported, resultData: result, csvData: csvData, csvName: csvName, callbackDelete: onDelete, closeModal: function () { }, selectService: selectService, errorMessage: errorMessage, isUpdate: isUpdate, selectedAction: selectedAction }), !isUpdate && (_jsx("div", __assign({ className: "btn-import-subscribers" }, { children: _jsx("button", __assign({ className: "blue-button", onClick: onConfirmImport }, { children: "Importar" })) })))] }))] }));
}
export default UploadArea;
